export default {
  en: {
    reply: 'Reply',
    comment: 'Comment',
    cancel: 'Cancel',
    add_a_comment: 'Add a comment...',
    add_a_reply: 'Add a reply...',
    snack: {
      generic_error_msg:
        'Something went wrong! Please try again later or contact us.',
    },
  },
};
